import {
  mapSurveyLocalization,
  Survey,
  SurveyLocaleData,
} from '@ps/survey-utils';

export function distinctLocalesOf(
  surveys: readonly Survey[],
): SurveyLocaleData[] {
  const localeByKey = new Map(
    surveys.map(({ countryCode, languageShortCode }) => [
      mapSurveyLocalization(countryCode, languageShortCode),
      { countryCode, languageShortCode },
    ]),
  );

  return [...localeByKey.values()];
}
